import React from "react";

import { Typography } from "@mui/material";

import { Theme } from "../../../../Style/Theme";

/**
 * this subheading is the main subheading type
 * font is color is light grey
 * ?Color:#8E8E93
 * @param text : prop is used to display the given text
 *
 */
export const SubHeader = ({ text, icon, color, gap, marginLeft }) => {
  return (
    <WrapText
      marginLeft={marginLeft}
      icongap={gap}
      isIcon={icon ? true : false}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        {icon}
      </div>
      <Typography
        fontWeight={400}
        fontSize={"13px"}
        lineHeight={"18px"}
        fontStyle={"normal"}
        color={color || Theme.palette.text.grayLight}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

/**
 * this subheading is the main subheading type
 * font is color is dark grey
 * ?Color:#37373A
 * font size is same as type 1
 * font line height also same
 * @param text : prop is used to display the given text
 *
 */
export const SubHeader2 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"13px"}
        lineHeight={"18px"}
        fontStyle={"normal"}
        letterSpacing={"-0.078px"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

/**
 * this subheading is the main subheading type
 * font is color is dark grey
 * ?Color:#8E8E93
 * font size is smaller when comparing type 1 and type 2
 * font line height also smaller than type 1 and type 2
 * @param text : prop is used to display the given text
 *
 */
export const SubHeader3 = ({ text, icon }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={300}
        fontSize={"11px"}
        lineHeight={"13px"}
        color={Theme.palette.text.grayLight}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const SubHeader4 = ({ text, icon, icongap, color }) => {
  return (
    <WrapText isIcon={icon ? true : false} icongap={icongap}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"15px"}
        lineHeight={"20x"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const SubHeader5 = ({ text, icon, icongap, color }) => {
  return (
    <WrapText isIcon={icon ? true : false} icongap={icongap}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"10px"}
        lineHeight={"14x"}
        color={color ? color : Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const SubHeader6 = ({ text, icon, icongap, color }) => {
  return (
    <WrapText isIcon={icon ? true : false} icongap={icongap}>
      {icon}
      <Typography
        fontWeight={500}
        fontSize={"14px"}
        letterSpacing={"-0.078px"}
        lineHeight={"18x"}
        color={color || "#37373A"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

const WrapText = ({ children, isIcon, icongap, marginLeft }) => {
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        gap: isIcon ? (icongap ? icongap : "8px") : undefined,
        marginLeft,
      }}
    >
      {children}
    </span>
  );
};
